import { g as r } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as s, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconDialpadAi",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, p = ["aria-label", "data-qa", "aria-hidden"], f = ["clip-path"], m = ["id"];
function _(e, i, d, h, g, t) {
  return n(), s("svg", {
    "aria-label": d.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--dialpad-ai"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Dialpad Ai",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      fill: "currentColor"
    }, [...i[0] || (i[0] = [
      a("path", { d: "M10.721 2.916a.958.958 0 1 0 0-1.916.958.958 0 0 0 0 1.916Z" }, null, -1),
      a("path", {
        "fill-rule": "evenodd",
        d: "M4.591 2.694c-.217 0-.59.207-.785.841v.002L1.964 9.473a.749.749 0 0 1-1.43-.444l1.84-5.932v-.002c.3-.975 1.084-1.899 2.217-1.899s1.916.922 2.216 1.896l1.417 4.57c.195.633.568.84.785.84a.963.963 0 0 0 .963-.963V4.411a.749.749 0 1 1 1.498 0v3.128A2.46 2.46 0 0 1 9.01 10c-1.132 0-1.916-.92-2.216-1.895l-1.418-4.57c-.195-.633-.567-.84-.785-.84Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, f),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...i[1] || (i[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, m)
    ])
  ], 10, p);
}
const D = /* @__PURE__ */ u(c, [["render", _]]);
export {
  D as default
};
//# sourceMappingURL=dialpad-ai.js.map
